/**
 * Which of four things an analytics board should render. Pure, so it is testable without a DOM.
 *
 * The distinction worth keeping: "the query succeeded and there is nothing to show" is not an
 * error. Live currently holds 23 enquiries with only 2 purchasers and 2 enquiry types, so several
 * boards legitimately have thin or empty segments — and an empty chart drawn confidently reads as
 * a measurement, where "nothing in this range" reads as the truth.
 */

export type BoardState = 'loading' | 'error' | 'empty' | 'ready'

export interface BoardInput {
  isLoading: boolean
  error: unknown
  /** True when the query succeeded but produced no rows. */
  isEmpty: boolean
}

export function boardState({ isLoading, error, isEmpty }: BoardInput): BoardState {
  if (isLoading) return 'loading'
  if (error) return 'error'
  if (isEmpty) return 'empty'
  return 'ready'
}
